import React, { Fragment } from 'react';
import ManageSadminUsers from './ManageSadminUsers';

const SadminUsers = () => {
    return (
        <Fragment>
            <ManageSadminUsers />
        </Fragment>
    );
};

export default SadminUsers;
